import  {useState} from 'react'

import Web3 from "web3";
import Web3Modal from "web3modal";
import Authereum from "authereum";
import WalletConnectProvider from "@walletconnect/web3-provider";



export const Wallet_model = () => {

    const [loading, setLoading] = useState(false);

    return {
    get web3Loading() {
    return loading
    },
    async getweb3(paramater) {
    let red = localStorage.getItem("red");
    console.log(red,paramater,"hala")
    setLoading(true);
    let web3Modal;
    let provider;
    let web3;
    let providerOptions;
    if(red == "binance" ){
        console.log("entra en el binance")

    providerOptions = {
    metamask: {
    id: "injected",
    name: "MetaMask",
    type: "injected",
    check: "isMetaMask"
    },
    walletconnect: {
    package: WalletConnectProvider, // required
    options: {
    rpc: { 56: 'https://bsc-dataseed1.defibit.io/', },
    network: red,
    qrcodeModalOptions: {
    mobileLinks: [
    "rainbow",
    "metamask",
    "argent",
    "trust",
    "imtoken",
    "pillar"
    ]
    }
    }
    },
    authereum: {
    package: Authereum // required
    },
    };

    }else if(red == "xdai"){
        console.log("entra en el xdai")
       
    providerOptions = {
        metamask: {
        id: "injected",
        name: "MetaMask",
        type: "injected",
        check: "isMetaMask"
        },
        walletconnect: {
        package: WalletConnectProvider, // required
        options: {
        rpc: { 100: 'https://poa.api.nodesmith.io/v1/dai/jsonrpc?apiKey=3ddaa0fb616d4da996944fe185344627', },
        network: red,
        qrcodeModalOptions: {
        mobileLinks: [
        "rainbow",
        "metamask",
        "argent",
        "trust",
        "imtoken",
        "pillar"
        ]
        }
        }
        },
        authereum: {
        package: Authereum // required
        },
        };

    }else{

        console.log("entra en infura")
 providerOptions = {
    metamask: {
    id: "injected",
    name: "MetaMask",
    type: "injected",
    check: "isMetaMask"
    },
    walletconnect: {
    package: WalletConnectProvider, // required
    options: {
    infuraId: "1760ba6f182649959e72f17e5c6065f8", // Required
    network: red,
    qrcodeModalOptions: {
    mobileLinks: [
    "rainbow",
    "metamask",
    "argent",
    "trust",
    "imtoken",
    "pillar"
    ]
    }
    }
    },
    authereum: {
    package: Authereum // required
    },
    };
    }
    web3Modal = new Web3Modal({
    network: red,
    cacheProvider: true,
    providerOptions
    });

    provider = await web3Modal.connect();
    provider.on("error", e => console.error("WS Error", e));
    provider.on("end", e => console.error("WS End", e));

    provider.on("disconnect", (error ) => {
    console.log(error);
    });
    provider.on("connect", (info) => {
    console.log(info);
    });
    web3 = new Web3(provider);
    setLoading(false);
    return web3;
    },
    }

    }